import * as React from "react";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import { TableButton } from "@duosoftbg/nacid-components";
import SearchTable from "../../base/table/SearchTable";
import { ACADEMIC_RECOGNITION_TYPE } from "../../../../../../config/registers/common";

const headCells = [
  {
    id: "options",
    label: "",
  },
  {
    id: "recognizedUniversity",
    label: "l.table.head.university",
  },
  {
    id: "applicant",
    label: "l.diplomaOwner",
  },
  {
    id: "university",
    label: "l.table.head.foreignUniversity",
  },
  {
    id: "universityCountry",
    label: "l.table.head.country",
  },
  {
    id: "educationLevel",
    label: "l.acquiredEduLevel",
  },
  {
    id: "diplomaSpeciality",
    label: "l.table.head.acquiredSpeciality",
  },
  {
    id: "recognizedEduLevelTxt",
    label: "l.recognizedEduLevel",
  },
  {
    id: "recognizedSpeciality",
    label: "l.table.head.recognizedSpeciality",
  },
  {
    id: "protocolNumber",
    label: "l.recognizeRejectOrder",
  },
  {
    id: "recognitionStatus",
    label: "l.decisionType",
  },
];

const RSearchAcademicRecognitionUniversitiesListTable = ({
  total,
  records,
  blockTable,
  onPageOrOrderChange,
  group,
  viewURL,
}) => {
  return (
    <SearchTable
      group={group}
      headCells={headCells}
      total={total}
      blockTable={blockTable}
      onPageOrOrderChange={onPageOrOrderChange}
    >
      <TableBody>
        {records.map((row) => {
          return (
            <TableRow
              hover
              key={row.id}
              style={{
                backgroundColor:
                  row?.nextRecognitionsCountForSearchTable && row?.nextRecognitionsCountForSearchTable > 0 && "#fff3e6",
              }}
            >
              <TableCell style={{ textAlign: "center" }}>
                <TableButton to={`${viewURL}${row.id}&type=${ACADEMIC_RECOGNITION_TYPE.UNIVERSITIES}`} />
              </TableCell>
              <TableCell>{row.recognizedUniversity}</TableCell>
              <TableCell>{row.applicant}</TableCell>
              <TableCell>{row.university}</TableCell>
              <TableCell>{row.universityCountry}</TableCell>
              <TableCell>{row.educationLevel}</TableCell>
              <TableCell>{row.diplomaSpeciality}</TableCell>
              <TableCell>{row.recognizedEduLevel}</TableCell>
              <TableCell>{row.recognizedSpeciality}</TableCell>
              <TableCell>{row.protocolNumber}</TableCell>
              <TableCell>{row.recognitionStatus && row.recognitionStatus.name}</TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </SearchTable>
  );
};

export default RSearchAcademicRecognitionUniversitiesListTable;
